import { useQuery } from "@tanstack/react-query";

import { fetchGitHubReviewRun, fetchGitHubReviewRuns } from "@/lib/api";

const isPending = (status: string) => status === "queued" || status === "running";

const hasPendingEvaluation = (status: string | undefined) =>
  status === "queued" || status === "running";

export function useGitHubReviewRuns() {
  return useQuery({
    queryKey: ["github-review-runs"],
    queryFn: fetchGitHubReviewRuns,
    refetchInterval: (query) =>
      query.state.data?.runs.some(
        (run) => isPending(run.status) || hasPendingEvaluation(run.evaluationRun?.status),
      )
        ? 5_000
        : 15_000,
  });
}

export function useGitHubReviewRun(id: string | null) {
  return useQuery({
    queryKey: ["github-review-run", id],
    queryFn: () => fetchGitHubReviewRun(id!),
    enabled: !!id,
    refetchInterval: (query) =>
      query.state.data &&
      (isPending(query.state.data.run.status) ||
        hasPendingEvaluation(query.state.data.run.evaluationRun?.status))
        ? 5_000
        : query.state.data?.run.status === "posted" && !query.state.data.run.evaluationRun
          ? 15_000
          : false,
  });
}
